/* Copyright (c) 2017 Backpack Health LLC */

import { applyMiddleware, createStore, compose } from 'redux'
import createBrowserHistory from 'history/createBrowserHistory';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunkMiddleware from 'redux-thunk';

// import {createLogger} from 'redux-logger'
// import {promiseMiddleware, localStorageMiddleware} from './middleware'
import reducer from './reducer'

export const history = createBrowserHistory();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function createStoreWithState(state = {}) {
  return createStore(
    connectRouter(history)(reducer),
    state,
    composeEnhancers(
      applyMiddleware(thunkMiddleware, routerMiddleware(history))
    )
  )
}

export const appStore = createStoreWithState();

export default createStoreWithState

